import CryptoJS from 'crypto-js';

/**
 *
 * @param {*} roles
 * @param {*} roleName
 */

export function verifyRoles(roles, roleName) {
  let allowedRoles = [];
  let hasPermission;

  const decrypt = CryptoJS.AES.decrypt(roles, 'ultragaz-roles');
  roles = JSON.parse(decrypt.toString(CryptoJS.enc.Utf8));

  roles.map(role => {
    return (allowedRoles = [...allowedRoles, role.name]);
  });

  let isAllowed = allowedRoles.filter(role => {
    if (role === roleName) {
      return true;
    } else {
      return false;
    }
  });

  if (isAllowed.length === 1) {
    hasPermission = true;
  } else {
    hasPermission = false;
  }

  return hasPermission;
}
